const CL = {
  countryConfig: {
    IBAN: {
      visible: false,
    },
    accountHolderDocNumber: {
      label: "bankDetails.accountHolderDocNumber",
      placeholder: "bankDetails.documentCedulaPlaceholderCh",
      visible: true,
      required: true,
    },
    accountNumber: {
      visible: true,
      required: true,
      label: "bankDetails.accountNumber",
    },
    swift: {
      required: true,
      visible: true,
      label: "bankDetails.swift",
    },
    bankAddress: {
      visible: false,
      required: false,
    },
    bankName: {
      visible: false,
      required: false,
    },
  },
};
export { CL };
